import React from "react";
import { Outlet } from "react-router-dom";

import { LocationMismatchModalInstance } from "@js/apps/admin/components/location-mismatch-modal";
import { useAppRedirects } from "@js/apps/common/hooks/app-redirects";
import { useForcePageRemount } from "@js/apps/common/hooks/force-page-remount";
import { MessengerProvider } from "@js/apps/messenger/components/messenger-provider";
import { CommonConfirmationModal, ModalInstance } from "@js/components/modal";
import RequestLoader from "@js/components/request-loader";
import { RedirectWarningnModal, useAppSelector } from "@js/hooks";
import { useUpdateScrollPosition } from "@js/hooks/update-scroll-position";
import { AmplitudeAnalyticsProvider } from "@js/services/analytics/amplitude-analytics-provider";

import { LiveSiteNotifications } from "../../notifications/components/live-site-notifications";
import { OTPModals } from "../components";
import { AccountDependantProviders } from "../components/account-dependant-providers";
import { CommonWebsocketEventListenerProvider } from "../components/common-websocket-event-listener-provider";
import { useConfirmPageApiError } from "../hooks";
import { useUserInOtherTabsChanged } from "../hooks/use-user-in-other-tabs-changed";
import { GoogleAnalytics } from "../services/google-analytics";

export const App = () => {
  const appLayoutKey = useAppSelector((state) => state.common.appLayoutKey);

  useUpdateScrollPosition();
  useForcePageRemount();
  useAppRedirects();
  useConfirmPageApiError();
  useUserInOtherTabsChanged();

  return (
    <>
      <RequestLoader />
      <LiveSiteNotifications />
      <AmplitudeAnalyticsProvider />
      <GoogleAnalytics />
      <ModalInstance />
      <MessengerProvider />
      <CommonConfirmationModal />
      <RedirectWarningnModal />
      <OTPModals />
      <LocationMismatchModalInstance />
      <AccountDependantProviders />
      <CommonWebsocketEventListenerProvider />
      <React.Fragment key={appLayoutKey}>
        <Outlet />
      </React.Fragment>
    </>
  );
};
